export const formatWords = (defaultValue = "--", ...words) => {
  const capitalizeWord = (word) => {
    if (word === "-") return word;
    return word
      ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      : "";
  };

  return (
    words
      .filter((part) => part && typeof part === "string")
      .flatMap(word => word.split(' ').map(capitalizeWord))
      .join(" ") || defaultValue
  );
};
export function formatWords2(input) {
  if (typeof input !== 'string') return '-';

  return input
    .split(' ')
    .map(word => {
      if (word === 'undefined') return '-';
      const cleaned = word.replace(/[()]/g, '');
      if (/^(EMP|CS|CON|REF)-\d+$/i.test(cleaned)) return word;

      const alpha = word.replace(/[^a-zA-Z]/g, '');
      if (alpha && (alpha === alpha.toLowerCase() || alpha === alpha.toUpperCase())) {
        const firstLetterIndex = word.search(/[a-zA-Z]/);
        if (firstLetterIndex !== -1) {
          return (
            word.slice(0, firstLetterIndex) +
            word.charAt(firstLetterIndex).toUpperCase() +
            word.slice(firstLetterIndex + 1).toLowerCase()
          );
        }
      }

      return word;
    })
    .join(' ');
}
export const formatCurrency = (amount, fallback = "$0") => {
  if (typeof amount !== "number" || isNaN(amount) || !amount) {
    return fallback;
  }
  return `${amount.toFixed(2) < 0 ? '-' : ''}$${Math.abs(amount.toFixed(2)).toLocaleString()}`;
};

export function formatPhone(code, number) {
  if (number == null) return "-";

  const raw = String(number);
  const digits = raw.replace(/\D/g, "");

  // US number formatting
  if (code === "+1" && digits.length === 10) {
    return `${code} (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Fallback: international / unformatted
  return `${code} ${digits}`;
}


export function formatPhoneNumberLength(code, number) {
  if (number == null) return number;
  const raw = String(number);
  // Special case: "+1 17846545648"
  if (raw.startsWith("+") && raw.includes(" ")) {
    const parts = raw.split(" ");
    const plusPart = parts[0]; // "+1"
    let secondPart = parts[1] || "";
    if (secondPart.startsWith("1")) {
      secondPart = secondPart.slice(1);
    }
    return `${plusPart} ${secondPart}`;
  }
  // NEW condition: "+117342864045"
  if (raw.startsWith("+") && raw[1] === "1" && !raw.includes(" ")) {
    const digits = raw.replace(/\D/g, "");
    if (digits.length > 10) {
      const lastTen = digits.slice(-10);
      return `${lastTen}`;
    }
  }

  let digits = raw.replace(/\D/g, "");
  // US number formatting
  if (code === "+1" && digits.length > 10) {
    if (digits.startsWith("1")) {
      digits = digits.slice(1);
    }
  }
  // Fallback: international / unformatted
  return `${digits}`;
}